export default __webpack_public_path__ + "static/media/meudindin.da95becc.jpg";